<template>
  <div>
    <project-index :tableColCheck="tableColCheck" plat-name="metabo">
      <span slot="projectSign" slot-scope="{text,record}">
        代谢组-{{ text.value }}
      </span>
    </project-index>
  </div>
</template>


<script>
import ProjectIndex from "@/components/project/ProjectIndex.vue";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  components: {
    ProjectIndex
  },
  data() {
    return {
      tableColCheck: {
        isShow: true,
        name: 'metabo_col2'
      }
    }
  }
}
</script>

<style scoped>
::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap;
}

/deep/ .wMyTable .ant-table-body {
  max-height: 700px !important;
}

/deep/ .viewIcon i {
  color: #2978ca !important;
}
</style>

